import React from "react";
import qs from "query-string";
import { withI18n } from "react-i18next";
import { withRouter } from "react-router-dom";
import styled, { css } from "styled-components";
import Button from "common/Button";
import CWBLabsFooter from "common/CWBLabsFooter";
import HorizontalDivider from "common/HorizontalDivider";
import LegalSection from "common/LegalSection";
import * as SharedStyle from "common/SharedStyledComponents";
import Typography from "common/Typography";
import ErrorIcon from "images/error.svg";

const TokenExpired = ({ t, history, location }) => {
  const redirectForgotPwd = () => {
    history.push(`/login/forgotpwd${location.search}`);
  };

  const isCWBLabs = qs.parse(location.search).cwblabs;

  return isCWBLabs ? (
    <Base isCWBLabs>
      <Card>
        <Icon src={ErrorIcon} />
        <Typography align="center" component="h1" variant="h3">
          {t("Token Expired")}
        </Typography>
        <HorizontalDivider destructive />
        <Typography align="center">
          {t(
            "The reset token you have is expired. You can request a new token by clicking on the link below"
          )}:
        </Typography>
        <StyledButton destructive onClick={redirectForgotPwd}>
          {t("Request new token")}
        </StyledButton>
      </Card>
      <CWBLabsFooter />
    </Base>
  ) : (
    <Base>
      <Wrapper>
        <SharedStyle.FormWrapper>
          <SharedStyle.FormHeaderError>
            {t("TOKEN EXPIRED")}
          </SharedStyle.FormHeaderError>
          <SharedStyle.FormBody>
            <SharedStyle.StyledP>
              {t(
                "The reset token you have is expired. You can request a new token by clicking on the link below"
              )}
              :
            </SharedStyle.StyledP>
            <SharedStyle.SubmitDangerButton
              className="cwb-btn-primary"
              onClick={redirectForgotPwd}
            >
              {t("Request new token")}
            </SharedStyle.SubmitDangerButton>
          </SharedStyle.FormBody>
          <LegalSection />
        </SharedStyle.FormWrapper>
      </Wrapper>
    </Base>
  );
};

const Base = styled.div`
  width: 100%;
  height: calc(100vh - 60px);
  padding: 10vh 0;

  @media (max-width: 375px) {
    padding: 5vh 0;
  }

  ${(p) => p.isCWBLabs && css`
    height: calc(100vh - 80px);
    background-color: #040F1C;
  `}
`;

const Wrapper = styled.div`
  width: 610px;
  margin: auto;
  background: white;

  @media (max-width: 610px) {
    width: 100%;
  }
`;

const Card = styled.div`
  width: 400px;
  display: flex;
  flex-flow: column nowrap;
  margin: auto;
  padding: 16px 18px 24px;
  background-color: #FFFFFF;
  border-top: 6px solid #E5084A;
  border-radius: 4px;

  @media (max-width: 375px) {
    width: unset;
    margin: 0 16px;
  }
`;

const Icon = styled.img`
  width: 30px;
  height: auto;
  align-self: center;
  margin-bottom: 8px;
`;

const StyledButton = styled(Button)`
  margin-top: 16px;
`;

export default withI18n()(withRouter(TokenExpired));
